/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type WorkingModeApplyLeafSpecRuleId =
  (typeof WorkingModeApplyLeafSpecRuleId)[keyof typeof WorkingModeApplyLeafSpecRuleId];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkingModeApplyLeafSpecRuleId = {
  essayobjectives_present: 'essay.objectives_present',
  essayrubric_present: 'essay.rubric_present',
  oralquestion_pool_present: 'oral.question_pool_present',
} as const;
